'use client';

import React, { useContext } from 'react';
import { FaceFrownIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';
import { Icon } from '@nalgoo-ui-private/nalgoo-ui';
import classNames from 'classnames';
import { GateStyleContext } from './GateStyleContext';

const messages = {
	en: {
		heading: 'This job offer doesn’t exist.',
		backToHomepage: 'Back to homepage',
	},
	sk: {
		heading: 'Táto pracovná ponuka neexistuje.',
		backToHomepage: 'Naspäť na domovskú stránku',
	},
	cs: {
		heading: 'Tato nabídka práce neexistuje.',
		backToHomepage: 'Zpět na domovskou stránku',
	},
	de: {
		heading: 'Dieses Stellenangebot gibt es nicht.',
		backToHomepage: 'Zurück zur Startseite',
	},
	hu: {
		heading: 'Ez az állásajánlat nem létezik.',
		backToHomepage: 'Vissza a honlapra',
	},
};

export default function RenderError() {
	const { dark } = useContext(GateStyleContext);

	let locale = navigator?.language;
	if (!messages[locale]) {
		locale = 'en';
	}

	return (

		<div className="p-4">
			<div className={classNames(dark ? 'text-white' : 'text-gray-900', 'space-y-4 text-center')}>
				<div className="flex-shrink-0 text-center">
					<FaceFrownIcon className="h-24 w-24 mx-auto" />
				</div>
				<h2 className="text-blue-600 text-4xl">
					404
				</h2>
				<div className="ml-3">
					<h3 className="text-sm font-medium">
						{messages[locale].heading}
					</h3>
					<div className="mt-2 text-sm">
						<Link href="/" className="inline-flex gap-2">
							<Icon.LongLeftArrow />
							{messages[locale].backToHomepage}
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
}
